<style scoped>
.text-center {
  text-align: center;
}
</style>

<template>
  <v-card outlined class="">
    <v-card-title class="text-subtitle-1 font-weight-bold">{{
      $t('distribution.classCode.title')
    }}</v-card-title>
    <v-card
      class="mx-4 flat text-center"
      color="blue-grey lighten-5"
      flat
      rounded="lg"
    >
      <v-card-text class="pb-2">{{
        $t('distribution.classCode.description')
      }}</v-card-text>
      <div class="pt-0 pb-4 text-h3 font-weight-bold">
        {{ classCode || '-' }}
      </div>
    </v-card>
    <v-card-actions class="px-4 py-3">
      <v-btn
        block
        depressed
        outlined
        color="blue-grey darken-5"
        @click="copyClassCode"
        :disabled="!classCode"
      >
        <v-icon class="mr-2" size="medium">mdi-content-copy</v-icon>
        {{ $t('distribution.classCode.buttonText') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import { copyToClipboard } from "@/utils/distributionUtils";

export default defineComponent({
  name: "ClassCode",
  props: {
    classCode: {
      type: String,
      default: null,
    },
  },
  methods: {
    async copyClassCode() {
      if (!this.classCode) {
        return;
      }

      await copyToClipboard(
        this.classCode,
        this.$t("distribution.classCode.copySuccess") as string,
        this.$t("distribution.classCode.copyError") as string,
        this.$root.$emit.bind(this.$root),
      );
    },
  },
});
</script>
